export enum AssignmentEventTypeEnum {
    ReadOnly = 'ReadOnly',
    RouteToDetails = 'RouteToDetails',
    RouteToPastDetails = 'RouteToPastDetails',
    Checkbox = 'Checkbox',
    Modal = 'Modal',
    CustomAction = 'CustomAction',
}
